import type { KeyframeRendererProvider, SavedKeyframeRow } from '@/modules/keyframes/types';
import type { RendererBridge } from '@/modules/rendererBridge';
import { keyframeFromLegacy, type LegacyKeyframe } from '@/infrastructure/api/v1/mappers/keyframes';

/** Tells the renderer about keyframes over the bridge, in the v1 shape the save returned. */
export class KeyframeBridgeAdapter implements KeyframeRendererProvider {
  constructor(private readonly bridge: RendererBridge) {}

  keyframeAdded(row: SavedKeyframeRow): void {
    this.bridge.send({ type: 'keyframeAdded', keyframe: keyframeFromLegacy(row as unknown as LegacyKeyframe), restored: false });
  }

  keyframeUpdated(row: SavedKeyframeRow): void {
    this.bridge.send({ type: 'keyframeUpdated', keyframe: keyframeFromLegacy(row as unknown as LegacyKeyframe) });
  }

  keyframeRemoved(keyframeId: string, assetInstanceId: string): void {
    this.bridge.send({ type: 'keyframeRemoved', keyframeUniqueId: keyframeId, assetInstanceUniqueId: assetInstanceId });
  }

  selectKeyframe(keyframeId: string, assetInstanceId: string): void {
    this.bridge.send({ type: 'selectKeyframe', keyframeUniqueId: keyframeId, assetInstanceUniqueId: assetInstanceId });
  }
}
